export default "__VITE_ASSET__BewNUAt0__"